export type NOT_FAN_ACTION = 'mute' | 'block'

export const NOT_FAN_OPTIONS = [
  {
    value: 'block' as NOT_FAN_ACTION,
    title: 'Block',
    description:
      'Blocked users will not be able to follow you or see your content, and you will not see any content from them. They will also be aware that they have been blocked.',
  },
  {
    value: 'mute' as NOT_FAN_ACTION,
    title: 'Mute',
    description:
      'Muted users can still follow you and see your content, but you will not see any content from them. They will not know that they have been muted.',
  },
]
